import * as THREE from "three"
import { SVGLoader } from "three/examples/jsm/Addons"
import { Flame } from "./flame"

export class Satellite{
	group : THREE.Group
	scene : THREE.Scene

	add_to_scene = () =>{
		const loader = new SVGLoader();

		loader.load("satellite.svg", ( data ) => {

			this.group.scale.multiplyScalar( 0.005 );
			this.group.rotateOnAxis(new THREE.Vector3(0,0,1), THREE.MathUtils.degToRad(135));
			this.group.position.x = 1.8;
			this.group.position.y = 40;
			this.group.position.z = 0;
			let renderOrder = 0;

			for ( const path of data.paths ) {

				const fillColor = path.userData.style.fill;

				if ( fillColor !== 'none' ) {

					const material = new THREE.MeshBasicMaterial( {
						color: new THREE.Color().setStyle( fillColor ),
						opacity: path.userData.style.fillOpacity,
						transparent: true,
						side: THREE.DoubleSide,
						depthWrite: false,
					} );

					const shapes = SVGLoader.createShapes( path );

					for ( const shape of shapes ) {

						const geometry = new THREE.ShapeGeometry( shape );
						const mesh = new THREE.Mesh( geometry, material );
						mesh.renderOrder = renderOrder ++;

						this.group.add( mesh );
					}

				}
				else{
					console.log("Fill colour is none.");
				}


				this.scene.add(this.group);
			}
		});
	}

	animate(multiplier : number, flame_object : Flame | null = null){

		if(this.group.position.y > 26){
			this.group.position.y -= 0.02 * multiplier;
		}
	
		if(flame_object != null){
			if(this.group.position.y < 28){
				flame_object.show();
			}
			else{
				flame_object.hide();
			}
		}
	}

	thrust(multiplier : number){
		if(this.group.position.y < 45){
			this.group.position.y += Math.min(2.5, (0.2 * Math.max(1 / multiplier, 2)));	
		}
	}

	constructor(scene: THREE.Scene){
		this.group = new THREE.Group();
		this.scene = scene;
	}
}